/**
 * Retrieves the font family from primary or overrides from the theme.
 *
 * @param {string} fontFamilyType
 * @param {string} fontWeight
 * @param {Object} theme
 * @param {string} typePreset
 * @returns {string} fontFamily
 */
export default function getFontFamily({
  fontFamilyType,
  fontWeight,
  theme,
  typePreset
}) {
  const ffType = fontFamilyType === 'secondary' ? 'sec' : 'pri';

  return (
    theme?.text?.[typePreset]?.fontFamily ?? theme[`ff_${ffType}_${fontWeight}`]
  );
}
